import { Component, Input } from '@angular/core';
import { createLink } from 'src/app/components/profile/user-profile/view-profile/regular-user-profile/regular-user-profile-helper';
import { UserInfo } from 'src/app/interfaces';

@Component({
  selector: 'app-user-info',
  templateUrl: './user-info.component.html',
  styleUrls: ['./user-info.component.scss'],
})
export class UserInfoComponent {
  @Input({ required: true }) public userInfo: UserInfo;

  @Input({ required: false }) public srtIndex = 0;
  @Input({ required: false }) public hasTableSizeLimit = false;
  @Input({ required: false }) public hasConnectionSizeLimit = false;
  @Input({ required: false }) public redirectToLoginIfNoSession = false;

  public getLink(user: UserInfo): string {
    return createLink(user.userStatus, user.userId);
  }
}
